import { useTranslation, Trans } from 'react-i18next';
import { TextField } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import WixAuthVisual from './WixAuthVisual';

const FIELD_SX = {
  backgroundColor: '#fff',
  '& .MuiOutlinedInput-root': { borderRadius: '10px' },
  '& .MuiOutlinedInput-root.Mui-focused fieldset': { border: '1px solid #515151' },
  '& .MuiInputLabel-root': { color: 'gray' },
  '& .MuiInputLabel-root.Mui-focused': { color: '#5616ea' },
};

// One account form for the original Wix app and every acquisition app.
export default function WixAccountForm({ authMode, setAuthMode, firstName, setFirstName,
  userEmail, setUserEmail, pw, setPw, pw2, setPw2, emailExists, setEmailExists,
  err, setErr, loading, handleRegister, handleLogin }) {
  const { t } = useTranslation();
  return (
              <div className="wxo-card wxo-card-auth">
                <div className="wxo-auth-form">
                {authMode === 'register' ? (
                  <>
                    <h2 className="wxo-h2">{t('wxo_reg_title')}</h2>
                    <p className="wxo-sub">{t('wxo_reg_sub')}</p>
                    <form onSubmit={handleRegister} autoComplete="on">
                      <div className="wxo-field"><TextField label={t('wxo_first_name')} name="firstName" autoComplete="given-name" value={firstName} onChange={(e) => setFirstName(e.target.value)} fullWidth variant="outlined" required sx={FIELD_SX} /></div>
                      <div className="wxo-field"><TextField label={t('wxo_email')} name="email" type="email" autoComplete="email" value={userEmail} onChange={(e) => setUserEmail(e.target.value)} fullWidth variant="outlined" required sx={FIELD_SX} /></div>
                      <div className="wxo-field"><TextField label={t('wxo_password')} name="new-password" type="password" autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} fullWidth variant="outlined" required inputProps={{ minLength: 8 }} sx={FIELD_SX} /></div>
                      <div className="wxo-field"><TextField label={t('wxo_confirm_password')} name="confirm-password" type="password" autoComplete="new-password" value={pw2} onChange={(e) => setPw2(e.target.value)} fullWidth variant="outlined" required inputProps={{ minLength: 8 }} sx={FIELD_SX} /></div>
                      {(emailExists || err) && (
                        <div className="wxo-err">
                          {emailExists
                            ? <Trans i18nKey="wxo_err_email_registered" components={[<button type="button" key="login" className="wxo-err-link" onClick={() => { setEmailExists(false); setErr(''); setPw(''); setPw2(''); setAuthMode('login'); }} />]} />
                            : err}
                        </div>
                      )}
                      <button className="wxo-btn wxo-btn-wide" type="submit" disabled={loading}>{t('wxo_get_started')} {loading ? <span className="wxo-spin" /> : <FontAwesomeIcon icon={faArrowRight} />}</button>
                    </form>
                    <p className="wxo-link">{t('wxo_have_account')}{' '}<button type="button" onClick={() => { setErr(''); setEmailExists(false); setAuthMode('login'); }}>{t('wxo_log_in')}</button></p>
                  </>
                ) : (
                  <>
                    <h2 className="wxo-h2">{t('wxo_login_title')}</h2>
                    <p className="wxo-sub">{t('wxo_login_sub')}</p>
                    <form onSubmit={handleLogin} autoComplete="on">
                      <div className="wxo-field"><TextField label={t('wxo_email')} name="email" type="email" autoComplete="email" value={userEmail} onChange={(e) => setUserEmail(e.target.value)} fullWidth variant="outlined" required sx={FIELD_SX} /></div>
                      <div className="wxo-field"><TextField label={t('wxo_password')} name="password" type="password" autoComplete="current-password" value={pw} onChange={(e) => setPw(e.target.value)} fullWidth variant="outlined" required sx={FIELD_SX} /></div>
                      <div className="wxo-forgot-row">
                        <a className="wxo-forgot-link" href="/forgot-password" target="_blank" rel="noopener noreferrer">{t('login_forgot_password')}</a>
                      </div>
                      {err && <div className="wxo-err">{err}</div>}
                      <button className="wxo-btn wxo-btn-wide" type="submit" disabled={loading}>{t('wxo_log_in')} {loading ? <span className="wxo-spin" /> : <FontAwesomeIcon icon={faArrowRight} />}</button>
                    </form>
                    <p className="wxo-link">{t('wxo_new_here')}{' '}<button type="button" onClick={() => { setErr(''); setEmailExists(false); setPw(''); setPw2(''); setAuthMode('register'); }}>{t('wxo_create_account')}</button></p>
                  </>
                )}
                </div>
                <div className="wxo-auth-visual"><WixAuthVisual /></div>
              </div>
  );
}
